/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../_redux/actions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { EditForm } from "./EditForm";
import { ModalProgressBar } from "../../../../../_metronic/_partials/controls";
import {CONTEXT, CONTEXT_TITLE} from "../../helpers/ModuleHelpers";
import {useIntl} from "react-intl";
import {actionTypes} from "../../_redux/slice";
import {HTTP_CREATED, HTTP_UPDATED} from "../../../../../_emywork/helpers/AxiosHelpers";
import {AEMetadata} from "../../../../../_emywork/AEPagination";

export function Edit({ history, match: { params: { id }, }}) {
  // Subheader
  const {formatMessage} = useIntl();
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { isLoading, entity, validationErrors } = useSelector(
    (state) => {
      const { isLoading, entity, validationErrors } = state[CONTEXT][actionTypes.Edit];
      return { isLoading, entity, validationErrors }
    },
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchEntity(
      id,
      new AEMetadata({},{},{},['*'])
    ));
  }, [id, dispatch]);

  useEffect(() => {
    setTitle(
      formatMessage(
        {id: 'FORM.TITLE'},
        {isNew:entity && id, name: formatMessage({id:CONTEXT_TITLE.singular}) }
        ));
  }, [entity, id]);

  const saveEntity = (values, files) => {
    if (!id) {
      dispatch(actions.createEntity(values, files)).then((r) => {
        if(r.status === HTTP_CREATED) {
          history.goBack()
        }
      });
    } else {
      dispatch(actions.updateEntity(values)).then((r) =>{
        if(r.status === HTTP_UPDATED) {
          history.goBack()
        }
      } )
    }
  };

  const btnRef = useRef();  
  const saveClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  return (
    <Card>
      {isLoading && <ModalProgressBar />}
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type="button"
            onClick={history.goBack}
            className="btn btn-light"
          >
            <i className="fa fa-arrow-left"/>
            {formatMessage({id:'BACK'})}
          </button>
          <button
            type="submit"
            className="btn btn-primary ml-2"
            onClick={saveClick}
          >
            {formatMessage({id:'SAVE'})}
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <EditForm
            isLoading={isLoading}
            entity={entity}
            btnRef={btnRef}
            saveEntity={saveEntity}
            validationErrors={validationErrors}
        />
      </CardBody>
    </Card>
  );
}
